import { createStyleSheet } from 'Components/foundation/stylesheets';

const FIXED_WIDTH = 1065;
const MK_OFFSET = 56; // to align the mk from the "on hover" appearing left box

const styles = createStyleSheet({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - (53px + 43px))',
    width: '100%',
    alignItems: 'center',
  },
  headerContainer: {
    display: 'flex',
    width: FIXED_WIDTH,
    height: 'fit-content',
  },
  bodyContainer: {
    width: FIXED_WIDTH + MK_OFFSET,
  },
  insertMkButtonContainer: {
    marginTop: 8,
    marginLeft: MK_OFFSET / 2,
    padding: '16px 0',
    width: FIXED_WIDTH,
    display: 'flex',
    justifyContent: 'center',
  },
  footerContainer: {
    width: FIXED_WIDTH,
    minHeight: 50,
  },
});

export default styles;
